<app-pesquisa [(showDialog)]="pesquisarDialog" (pessoa)="loadData($event)"></app-pesquisa>

<app-relatorio-container
    tituloRelatorio="Termo de Ciência e Compromisso"
    descricaoRelatorio="Termo de ciência (situação sem exercer medicina na UF)."
    categoriaRelatorio="Cadastro"
    [filtrosTemplate]="filtrosTemplate"
    [pdfBlob]="(job$ | async)?.pdfBlob"
    [pdfFileName]="(job$ | async)?.fileName ?? 'termo-ciencia-compromisso-medico.pdf'"
    [statusPreview]="(job$ | async)?.status ?? null"
    [progressoPreview]="(job$ | async)?.progress ?? 0"
>
    <ng-template #filtrosTemplate>
        <div class="flex flex-col gap-6">
            <p class="text-sm text-muted-color">
                O termo será emitido para o médico selecionado, declarando ciência de que a manutenção da inscrição decorre de processo ético-profissional ou sindicância em andamento e o impedimento de exercer a medicina neste estado. O próprio
                médico é o signatário do documento.
            </p>

            <app-card-medico-selecionado [pessoa]="pessoa()" [pessoaResponse]="pessoaResponse()" (alterar)="showPesquisarPessoa()"></app-card-medico-selecionado>

            <div class="field pt-5 flex justify-end gap-2">
                <p-button label="Limpar" icon="pi pi-eraser" [variant]="'text'" (click)="limparFormulario()"></p-button>
                <p-button
                    label="Gerar Termo"
                    icon="pi pi-file-pdf"
                    [appCan]="roleGerar"
                    (click)="gerarRelatorio()"
                    [loading]="isPending"
                    [disabled]="isPending || !possuiPessoaSelecionada"
                    pTooltip="Para gerar o relatório, selecione um médico."
                    tooltipPosition="top"
                    [tooltipDisabled]="possuiPessoaSelecionada"
                ></p-button>
            </div>
        </div>
    </ng-template>
</app-relatorio-container>
